import gql from 'graphql-tag'

export const demoTokenDelete = gql`
  mutation demoTokenDelete($demoTokenId: ID!) {
    demoTokenDelete(input: { demoTokenId: $demoTokenId }) {
      success
    }
  }
`
